<template lang="html">
  <div class="fade-in content-body">
      <div class="columns" :class="{ 'blur' : $root.blur }">
          <div class="column text-info">
            <p v-if="error_cert && !loading" class="has-text-centered">No se ha podido escanear el codigo QR.</p>
            <p v-else-if="error_cert" class="has-text-centered">No se han podido obtener los datos de este codigo QR.</p>
            <p v-else-if="paused" class="has-text-centered">Compuebe que los datos del establecimiento de comercio son validos.</p>
            <p v-else-if="!loading" class="has-text-centered">Coloque el codigo QR frente a la cámara.</p>
            <p v-else class="has-text-centered">Cargando...</p>
          </div>
      </div>
      <div v-if="information != null" class="card-show">
        <div class="image-icon fade-in-bounce">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" width="512px" height="512px">
            <g>
            	<g>
            		<path ref="pl" d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.331,26.629,74.98,74.98C26.628,123.332,0,187.62,0,256    s26.628,132.667,74.98,181.019C123.332,485.371,187.619,512,256,512c68.38,0,132.667-26.629,181.019-74.981    C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30    s226,101.383,226,226S380.617,482,256,482z" fill="#FFFFFF"/>
            	</g>
            </g>
            <g>
            	<g>
            		<path ref="sl" d="M378.305,173.859c-5.857-5.856-15.355-5.856-21.212,0.001L224.634,306.319l-69.727-69.727    c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l80.333,80.333c2.929,2.929,6.768,4.393,10.606,4.393    c3.838,0,7.678-1.465,10.606-4.393l143.066-143.066C384.163,189.215,384.163,179.717,378.305,173.859z" fill="#FFFFFF"/>
            	</g>
            </g>
          </svg>
        </div>
        <div class="info-enterprise-qr">
          <p class="title-enterprise">{{information.nombre}}</p>
          <p>Matricula: {{information.matricula}}</p>
          <p>Año de Renovación: {{information.ultanorenovado}}</p>
          <p>Fecha de Renovación: {{getDateRenovation}}</p>
        </div>
        <div v-if="paused">
          <div class="field">
            <p class="control has-text-centered button-new-read">
              <button class="button is-success" @click="newCert">
                <span class="icon">
                  <span class="retry"></span>
                </span>
                <span>
                  Consultar nuevo
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
      <div v-if="information != null" class="overflow-qr"></div>
      <qrcode-reader :class="{ 'blur' : $root.blur }" v-if="hidden" @decode="onDecode" @init="onInit" :paused="paused">
      </qrcode-reader>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error_cert: false,
      loading: false,
      paused: false,
      hidden: true,
      information: null
    }
  },
  computed:{
    getDateRenovation(){
      if(this.information != null){

        return moment(this.information.fecharenovacion).format('LL')
      }
      return ''
    }
  },
  methods: {
    newCert(){
      let vm = this
      vm.hidden = false
      vm.information = null
      vm.paused = false
      vm.$root.blur = false
      setTimeout(() => {
        vm.hidden = true
      }, 100)
    },
    onDecode (decodedString) {
      let vm = this
      vm.loading = true
      vm.error_cert = false
      vm.information = null
      vm.paused = true
      axios.get('https://control.ccmonteria.org.co/api/site/certificadoRenovacion/'+decodedString+'/json')
      .then(function(response) {
        vm.information = response.data.data
        vm.$root.blur = true
      })
      .catch(function(error) {
          try{
            console.log(error.response.data.message)
          }catch(err){
            vm.$root.message = "No se ha podido verificar el codigo QR."
            vm.$root.toast()
          }
          vm.error_cert = true
      })
      .then(function() {
        vm.loading = false
      })
    },
    async onInit (promise) {
      let vm = this
      vm.loading = true
        // show loading indicator
        try {
          await promise
          // successfully initialized
        } catch (error) {
          this.error_cert = true
          if (error.name === 'NotAllowedError') {
            vm.$root.message = "Permiso de acceso a la camara denegado."
            vm.$root.toast()
          } else if (error.name === 'NotFoundError') {
            vm.$root.message = "No se ha encontrado ninguna camara en su dispositivo."
            vm.$root.toast()
            // no suitable camera device installed
          } else if (error.name === 'NotSupportedError') {
            vm.$root.message = "El lector QR solo es permitido en paginas con HTTPS."
            vm.$root.toast()
            // page is not served over HTTPS (or localhost)
          } else if (error.name === 'NotReadableError') {
            vm.$root.message = "Error al conectar la camara, puede que esté en uso."
            vm.$root.toast()
            // maybe camera is already in use
          } else if (error.name === 'OverconstrainedError') {
            vm.$root.message = "No se ha podido encontrar la camara."
            vm.$root.toast()
            // passed constraints don't match any camera.
            // Did you requested the front camera although there is none?
          } else {
            vm.$root.message = "El lector QR no funciona en su navegador."
            vm.$root.toast()
            // browser might be lacking features (WebRTC, ...)
          }
        } finally {
          // hide loading indicator
          this.loading = false
        }
      }
  },
  mounted() {

  }
}
</script>

<style lang="sass" scoped>
  .overflow-qr
    position: fixed
    z-index: 2
    width: 100%
    height: 100%
    top: 0
    left: 0
  .content-body
    color: #00518f
  .text-info
    & p
      font-weight: bold
      font-size: 1.2rem
  .card-show
    position: fixed
    z-index: 3
    width: 40%
    padding: 20px
    background: #0c9af8
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    border-radius: 6px
    padding: 2em
    height: 50%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    color: #4f4f4f
    animation: 1s fade-in ease
    & .image-icon
      width: 100px
      margin-bottom: 10px
      & svg
        width: inherit
        height: auto
  .info-enterprise-qr
    text-align: center
    color: #fff
    font-weight: bold
    font-size: 1.2rem
    & .title-enterprise
      font-size: 2rem
      display: -webkit-box
      -webkit-font-smoothing: antialiased
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      overflow: hidden
  .retry
    background: url(../../images/reload.svg)
    background-size: 24px
    background-repeat: no-repeat
    background-position: center
    width: inherit
    height: inherit

  button
    margin-top: 50px
    background-color: rgba(15, 72, 121, 0.6) !important
    font-weight: bold
</style>



// WEBPACK FOOTER //
// resources/js/components/VerifyQr.vue